import { Component, OnInit } from '@angular/core';
import { EmailSettingService } from '@services/email-setting.service';
import { TableModule } from 'primeng/table';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-email-setting',
  templateUrl: './email-setting.component.html',
  styleUrl: './email-setting.component.scss'
})
export class EmailSettingComponent implements OnInit {
  public emailSettings:any=[];
  sidebarVisible4: boolean = false;
  public emailSettingId = 0;
  constructor(private emailSettingService:EmailSettingService){}

  ngOnInit(): void {
    this.getEmailSetting();
  }
  getEmailSetting() {
    this.emailSettingService.getEmailSettingList().subscribe(
      result => {
        this.emailSettings = result;
      }
    );
  }
  onEdit(id:number){
  
    this.sidebarVisible4 = true;
    this.emailSettingId = id;
   

  }
}
